module.exports = __webpack_public_path__ + "img/new-icon.0d37a1eb.svg";